import { servicesPageIntro, servicesPageSections } from "@/content/siteContent";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <section className="bg-slate-950 py-24 text-white md:py-28" data-testid="services-hero-section">
        <div className="mx-auto max-w-5xl px-6 md:px-12">
          <div className="space-y-6">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl" data-testid="services-hero-heading">
              Services
            </h1>
            {servicesPageIntro.map((paragraph, index) => (
              <p
                key={paragraph}
                className="max-w-4xl text-base text-slate-300 md:text-lg"
                data-testid={`services-intro-paragraph-${index + 1}`}
              >
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-24 md:py-28" data-testid="services-grid-section">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <div className="grid gap-8">
            {servicesPageSections.map((section, index) => (
              <article
                key={section.slug}
                className="border border-slate-200 bg-slate-50 p-8 md:p-10"
                data-testid={`services-page-card-${section.slug}`}
              >
                <div className="grid gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-start">
                  <div className={index % 2 === 1 ? "lg:order-2" : ""}>
                    <h2 className="text-3xl font-bold tracking-tight text-slate-950 md:text-4xl" data-testid={`services-page-card-title-${section.slug}`}>
                      {section.title}
                    </h2>
                    <p className="mt-4 text-base text-slate-700 md:text-lg" data-testid={`services-page-card-description-${section.slug}`}>
                      {section.description}
                    </p>
                    {section.listLead ? (
                      <p className="mt-6 text-base font-semibold text-slate-950" data-testid={`services-page-card-lead-${section.slug}`}>
                        {section.listLead}
                      </p>
                    ) : null}
                    <ul className="mt-6 grid gap-3 sm:grid-cols-2">
                      {section.items.map((item) => (
                        <li
                          key={item}
                          className="flex items-start gap-3 text-sm text-slate-700"
                          data-testid={`services-page-card-item-${section.slug}-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        >
                          <span className="mt-1 inline-flex h-2 w-2 rounded-full bg-orange-600" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  {section.image ? (
                    <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                      <div className="overflow-hidden border border-slate-200 bg-white shadow-sm" data-testid={`services-page-card-image-frame-${section.slug}`}>
                        <img
                          alt={section.title}
                          className="aspect-[4/3] w-full object-cover object-center"
                          data-testid={`services-page-card-image-${section.slug}`}
                          src={section.image}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
